module.exports = __webpack_public_path__ + "img/mianhua.330a6e4d.jpg";